// extracted by mini-css-extract-plugin
export default {"input":"FileButton_input__ot6SQ","label":"FileButton_label__HJ7Jp","spinner":"FileButton_spinner__r5lm5"};